import { Skeleton, SkeletonArea } from '@hello-aria/ui/skeleton'
import { useTranslations } from 'next-intl'

const SkeletonAvatar = () => {
    const t = useTranslations('root')

    return (
        <SkeletonArea label={t('loading.content')}>
            <Skeleton shape="circle" />
        </SkeletonArea>
    )
}

export default SkeletonAvatar
